export const REPLY_WINDOW_MS = 24 * 60 * 60 * 1000

export type ReplyWindow = {
  known: boolean
  open: boolean
  lastInboundAt: string | null
}

type MessagesPayload = {
  status?: number
  last_inbound_at?: string | null
}

/** La ventana de WhatsApp cuenta desde el último mensaje del cliente. */
export function replyWindow(payload: MessagesPayload | null | undefined, now = Date.now()): ReplyWindow {
  if (!payload || payload.status !== 200 || !Object.prototype.hasOwnProperty.call(payload, "last_inbound_at")) {
    return { known: false, open: true, lastInboundAt: null }
  }
  const raw = payload.last_inbound_at
  if (typeof raw !== "string" || !raw.trim()) {
    return { known: true, open: false, lastInboundAt: null }
  }
  const at = Date.parse(raw)
  if (Number.isNaN(at)) return { known: true, open: false, lastInboundAt: null }
  return {
    known: true,
    open: now - at < REPLY_WINDOW_MS,
    lastInboundAt: raw,
  }
}

export function closedWindowMessage(lastInboundAt: string | null, now = Date.now()): string {
  const tail = "WhatsApp no entrega un mensaje escrito a mano. Cuando te responda, ya puedes escribir normal."
  if (!lastInboundAt) {
    return `Este cliente todavía no ha escrito. ${tail}`
  }
  return `Este cliente no escribe desde hace ${agoLabel(lastInboundAt, now)}. ${tail}`
}

function agoLabel(iso: string, now: number): string {
  const elapsed = Math.max(0, now - Date.parse(iso))
  const hours = Math.floor(elapsed / (60 * 60 * 1000))
  if (hours < 48) {
    const h = Math.max(hours, 1)
    return h === 1 ? "1 hora" : `${h} horas`
  }
  const days = Math.floor(hours / 24)
  return days === 1 ? "1 día" : `${days} días`
}
